import { Tag, TTagVariant } from '@ui';
import React from 'react';
import type { TProviderStatus } from 'types/provider.types';

const COLOR_MAP: Record<TProviderStatus, TTagVariant> = {
  pending: 'info',
  pendingWithGuarator: 'info',
  approved: 'success',
  rejected: 'danger',
};

const TRANS_MAP: Record<TProviderStatus, string> = {
  pending: 'Čaká na schválenie',
  pendingWithGuarator: 'Čaká na schválenie s osobou',
  approved: 'Schválený',
  rejected: 'Odmietnutý',
};

interface ProviderStatusProps {
  status: TProviderStatus;
}

const ProviderStatus: React.FunctionComponent<ProviderStatusProps> = ({ status }) => {
  return <Tag variant={COLOR_MAP[status]}>{TRANS_MAP[status]}</Tag>;
};

export default ProviderStatus;
